module.exports = __webpack_public_path__ + "img/zhyly-5.b0979f6d.png";